function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Downshift from "downshift";
import delay from "lodash/delay";
import { isEmpty, noop, isFunction } from "lodash-es";
import { useRect } from "../../helpers/hooks";
import { useKeyboardMenuScroll } from "../../helpers/downshiftScroll";
import { BaseInput } from "../../base";
import { ExpandMore, Close, Search } from "../../icons";
import { Label } from "../label/Label";
import { useId, onEnter } from "../../helpers";
var TEXT_FIELD_OFFSET_WIDTH = 38;
var Select = function Select(_ref) {
  var _useRect;
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$prefixClassName = _ref.prefixClassName,
    prefixClassName = _ref$prefixClassName === void 0 ? "tui-select" : _ref$prefixClassName,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? undefined : _ref$error,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Select..." : _ref$placeholder,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 200 : _ref$maxHeight,
    _ref$clearable = _ref.clearable,
    clearable = _ref$clearable === void 0 ? false : _ref$clearable,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$emptyCase = _ref.emptyCase,
    emptyCase = _ref$emptyCase === void 0 ? "" : _ref$emptyCase,
    getRelativeViewportOffset = _ref.getRelativeViewportOffset,
    onInputChange = _ref.onInputChange,
    onBlur = _ref.onBlur,
    _ref$shouldFilter = _ref.shouldFilter,
    shouldFilter = _ref$shouldFilter === void 0 ? false : _ref$shouldFilter,
    inputPlaceholder = _ref.inputPlaceholder;
  var innerId = useId();
  var labelId = id || "tui-select-".concat(innerId);
  var selectRef = useRef();
  var optionsRef = useRef();
  var inputRef = useRef();
  var inputSearchRef = useRef();
  var rect = (_useRect = useRect(selectRef)) !== null && _useRect !== void 0 ? _useRect : {};
  var _useKeyboardMenuScrol = useKeyboardMenuScroll(),
    trackStateChange = _useKeyboardMenuScrol.trackStateChange,
    scrollIntoView = _useKeyboardMenuScrol.scrollIntoView;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItem = _useState6[0],
    setSelectedItem = _useState6[1];
  useEffect(function () {
    if (value !== undefined && value !== null && value !== "") {
      setSelectedItem(options.find(function (e) {
        return e.value === value;
      }) || {});
      return;
    }
    setSelectedItem({});
  }, [JSON.stringify(value || {}), JSON.stringify(options)]);
  useEffect(function () {
    var scrollCallback = function scrollCallback(e) {
      if (!optionsRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    window.addEventListener("wheel", scrollCallback);
    return function () {
      return window.removeEventListener("wheel", scrollCallback);
    };
  }, [selectRef]);
  useLayoutEffect(function () {
    var relativeViewportOffset = getRelativeViewportOffset === null || getRelativeViewportOffset === void 0 ? void 0 : getRelativeViewportOffset();
    var inputMargin = 4;
    var styles = {
      top: "".concat(relativeViewportOffset ? rect.top + rect.height + inputMargin - (relativeViewportOffset.top || 0) : rect.top + rect.height + inputMargin, "px"),
      left: "".concat(relativeViewportOffset ? rect.left - (relativeViewportOffset.left || 0) : rect.left, "px"),
      right: "".concat(rect.right, "px"),
      width: "".concat(rect.width, "px"),
      minHeight: "".concat(rect.height, "px"),
      transform: null
    };
    var collidesWithBottom = relativeViewportOffset !== null && relativeViewportOffset !== void 0 && relativeViewportOffset.clearanceHeight ? (relativeViewportOffset === null || relativeViewportOffset === void 0 ? void 0 : relativeViewportOffset.clearanceHeight) < maxHeight || window.innerHeight < rect.bottom + maxHeight : window.innerHeight < rect.bottom + maxHeight;
    if (collidesWithBottom) {
      styles.transform = "translateY(-100%) translateY(-".concat(rect.height + inputMargin * 2, "px)");
    }
    Object.entries(styles).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      optionsRef.current.style[key] = value;
    });
  }, [rect.top, rect.left, rect.right, rect.width, rect.height, rect.bottom, getRelativeViewportOffset]);
  var handleSearchInputChange = function handleSearchInputChange(event) {
    var value = event.target.value;
    setSearchText(value);
    if (isFunction(onInputChange)) {
      onInputChange(value);
    }
  };
  var onClearInput = function onClearInput() {
    setSearchText("");
    if (isFunction(onInputChange)) {
      onInputChange("");
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixClassName, "-wrapper ").concat(className),
    style: {
      display: readOnly && isEmpty(selectedItem) ? "none" : "initial"
    }
  }, /*#__PURE__*/React.createElement(Downshift, {
    isOpen: isOpen,
    onChange: function onChange(selection) {
      inputRef.current.blur();
      if ((selection === null || selection === void 0 ? void 0 : selection.value) !== selectedItem.value) {
        _onChange({
          target: selection
        });
      }
    },
    itemToString: function itemToString(item) {
      return (item === null || item === void 0 ? void 0 : item.label) || "";
    },
    selectedItem: selectedItem,
    onOuterClick: function onOuterClick(event) {
      if (!options.find(function (e) {
        return e.value === inputRef.current.value;
      }) && selectedItem.value === undefined) {
        inputRef.current.value = "";
      }
      if (onBlur) {
        onBlur(event);
      }
      setIsOpen(false);
      onClearInput();
    },
    scrollIntoView: scrollIntoView,
    stateReducer: function stateReducer(state, changes) {
      trackStateChange(changes);
      if (onInputChange || shouldFilter) {
        if ([Downshift.stateChangeTypes.mouseUp, Downshift.stateChangeTypes.blurInput].includes(changes.type)) {
          return _objectSpread(_objectSpread({}, changes), {}, {
            isOpen: state.isOpen
          });
        }
      }
      return changes;
    },
    onStateChange: function onStateChange(changes) {
      if (Object.prototype.hasOwnProperty.call(changes, "isOpen")) {
        setIsOpen(changes.isOpen);
      }
    }
  }, function (_ref4) {
    var getLabelProps = _ref4.getLabelProps,
      getInputProps = _ref4.getInputProps,
      getItemProps = _ref4.getItemProps,
      getMenuProps = _ref4.getMenuProps,
      selectedItem = _ref4.selectedItem,
      isOpen = _ref4.isOpen,
      openMenu = _ref4.openMenu,
      closeMenu = _ref4.closeMenu,
      inputValue = _ref4.inputValue;
    function onExpand(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled && !readOnly) {
        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
          if (onInputChange || shouldFilter) {
            delay(function () {
              if (inputSearchRef && inputSearchRef.current) {
                inputSearchRef.current.focus();
              }
            }, 100);
          }
        }
      }
    }
    function onClose(e) {
      e.preventDefault();
      e.stopPropagation();
      _onChange({
        target: {
          value: null
        }
      });
    }
    var filterOptions = selectedItem.label === inputValue ? options : options.filter(function (item) {
      return !inputValue || (item === null || item === void 0 ? void 0 : item.label.toLowerCase().includes(inputValue.toLowerCase()));
    });
    if (shouldFilter) {
      filterOptions = filterOptions.filter(function (_ref5) {
        var label = _ref5.label;
        return label === null || label === void 0 ? void 0 : label.toUpperCase().includes(searchText.toUpperCase());
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      // prevents downshift from auto adding prop
      "aria-labelledby": null,
      style: _objectSpread(_objectSpread({}, style), {}, {
        position: "relative"
      })
    }, label ? /*#__PURE__*/React.createElement(Label, _extends({}, getLabelProps({
      id: null
    }), {
      htmlFor: labelId,
      required: required
    }), label) : null, /*#__PURE__*/React.createElement("div", getInputProps({
      id: null,
      onClick: function onClick() {
        if (!disabled && !readOnly && !isLoading) {
          openMenu();
          if (onInputChange || shouldFilter) {
            delay(function () {
              if (inputSearchRef && inputSearchRef.current) {
                inputSearchRef.current.focus();
              }
            }, 100);
          }
        }
      },
      className: classNames("".concat(prefixClassName, "-option"), {
        "is-open": isOpen,
        "has-error": error,
        "read-only": readOnly,
        disabled: disabled || isLoading
      }),
      ref: selectRef,
      // prevents downshift from auto adding prop
      "aria-labelledby": null
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-loading-wrapper")
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixClassName, "-content")
    }, isLoading && /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      className: "loading-spinner"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "50",
      cy: "50",
      r: "45",
      className: "spinner"
    })))), /*#__PURE__*/React.createElement("input", {
      readOnly: true,
      className: classNames("".concat(prefixClassName, "-input"), {
        "clearable-space": clearable && !isEmpty(selectedItem)
      }),
      placeholder: placeholder,
      value: inputValue,
      id: labelId,
      ref: inputRef,
      disabled: disabled || isLoading
    }), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-icon-wrapper")
    }, clearable && !isEmpty(selectedItem) && /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: disabled || readOnly ? -1 : 0,
      className: "close-icon",
      onClick: onClose,
      onKeyPress: onClose,
      style: {
        display: readOnly ? "none" : "flex"
      }
    }, /*#__PURE__*/React.createElement(Close, null)), /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: disabled || readOnly ? -1 : 0,
      className: "expand-icon",
      onClick: onExpand,
      onKeyPress: onExpand,
      style: {
        display: readOnly ? "none" : "flex"
      }
    }, /*#__PURE__*/React.createElement(ExpandMore, null)))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixClassName, "-options-wrapper"),
      "aria-hidden": isOpen ? null : "true",
      ref: optionsRef,
      style: {
        position: "fixed",
        display: isOpen ? null : "none",
        zIndex: 11
      }
    }, isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, shouldFilter || onInputChange ? /*#__PURE__*/React.createElement(BaseInput, {
      ref: inputSearchRef,
      fluid: true,
      icon: true,
      placeholder: inputPlaceholder,
      onChange: handleSearchInputChange,
      value: searchText
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        paddingLeft: TEXT_FIELD_OFFSET_WIDTH
      }
    }), /*#__PURE__*/React.createElement("i", {
      className: "icon svg-wrapper",
      style: {
        left: 0
      }
    }, /*#__PURE__*/React.createElement(Search, null)), searchText && /*#__PURE__*/React.createElement("i", {
      role: "button",
      tabIndex: "0",
      className: "icon link svg-wrapper",
      onKeyPress: onEnter(onClearInput),
      onClick: onClearInput
    }, /*#__PURE__*/React.createElement(Close, {
      className: "close-icon"
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("ul", _extends({}, getMenuProps(), {
      className: classNames("".concat(prefixClassName, "-options"), {
        "has-error": error
      }),
      style: {
        maxHeight: maxHeight
      }
    }), filterOptions.length > 0 ? filterOptions.map(function (item, index) {
      return /*#__PURE__*/React.createElement("li", getItemProps({
        key: item.label.trim() ? "".concat(item.label, "-").concat(item.value) : emptyCase,
        index: index,
        item: item,
        className: classNames("".concat(prefixClassName, "-options-item"), {
          selected: item.value === selectedItem.value
        })
      }), item.label.trim() ? item.label : emptyCase);
    }) : /*#__PURE__*/React.createElement("li", {
      tabIndex: "-1",
      onFocus: function onFocus() {
        inputRef.current.focus();
      },
      className: "".concat(prefixClassName, "-options-item no-results")
    }, "No results found.")))));
  }), error && !isEmpty(error) ? /*#__PURE__*/React.createElement("div", {
    className: "tui-invalid-feedback",
    children: error
  }) : "");
};
Select.propTypes = {
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  clearable: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired
  })),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  maxHeight: PropTypes.number,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  prefixClassName: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  required: PropTypes.bool,
  emptyCase: PropTypes.string,
  getRelativeViewportOffset: PropTypes.func,
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  shouldFilter: PropTypes.bool,
  inputPlaceholder: PropTypes.string
};
export default Select;
//# sourceMappingURL=Select.js.map